module.exports = __webpack_public_path__ + "img/返回按钮.23a4e5fa.png";